import React, { CSSProperties, ReactChild } from 'react';
import { PopOver, OverlayTrigger } from '@tencent/spaui';
import { findDOMNode } from 'react-dom';
import './index.less';

export interface OverflowHoverTipProps {
  /**
   * 提示内容
   */
  tip: any;
  /**
   * 最大宽度
   */
  maxWidth?: number;
  /**
   * 样式
   */
  style?: CSSProperties;
  /**
   * 子元素（最好为inline元素，因为可自行展示省略号；inline-block和block需要children自行处理省略号展示）
   */
  children: ReactChild;
}

interface OverflowHoverTipState {
  showTip: boolean,
}

// 内容溢出时，hover展示tip
export class OverflowHoverTip extends React.Component<OverflowHoverTipProps, OverflowHoverTipState> {
  static defaultProps = {};
  timer = 0;

  constructor(props: OverflowHoverTipProps) {
    super(props);
    this.state = {
      showTip: false,
    };
  }

  componentDidMount = () => {
    // 如果内容是弹出的，那组件刚渲染时可能是没有宽度的，这样计算showTip结果会有误，因此延迟一会儿再计算
    this.timer = window.setTimeout(() => {
      this.timer = 0;
      this.computedShowTipStatus();
    }, 300);
  };

  componentWillUnmount(): void {
    this.timer && window.clearTimeout(this.timer);
  }

  computedShowTipStatus = () => {
    const currentDom = findDOMNode(this);
    if (!currentDom) {
      return;
    }
    const computedDom = currentDom.firstChild;
    if (!computedDom) {
      return;
    }
    // 若children为块元素，则其宽度与容器宽度相同，判断溢出需要使用children自身，即 computedDom.scrollWidth > computedDom.offsetWidth
    // 若children为行内元素，则其宽度可溢出容器，判断溢出使用容器与children宽度比较，即 currentDom.offsetWidth < computedDom.offsetWidth
    if (computedDom.scrollWidth > computedDom.offsetWidth
      || currentDom.offsetWidth < computedDom.offsetWidth) {
      this.setState({
        showTip: true,
      });
    }
  };

  render() {
    const children = (
      <div
        style={{
          maxWidth: this.props.maxWidth,
          ...this.props.style,
        }}
        className="overflow-hover-tip-content">
        {this.props.children}
      </div>
    );
    if (this.state.showTip) {
      return (
        <OverlayTrigger
          trigger="hover"
          placement="auto"
          defaultPlacement="bottom"
          autoPlacementBasic="window"
          hideDelayTime={0}
          overlay={<PopOver>{this.props.tip || this.props.children}</PopOver>}
        >
          {children}
        </OverlayTrigger>
      );
    }
    return children;
  }
}

OverflowHoverTip.defaultProps = {
  tip: '',
  style: {},
};

export default OverflowHoverTip;
